// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAGEjYplrvcdjmuroahGU3GxkLwn0WZ01k",
  authDomain: "portfolio-3953a.firebaseapp.com",
  projectId: "portfolio-3953a",
  storageBucket: "portfolio-3953a.firebasestorage.app",
  messagingSenderId: "435837327485",
  appId: "1:435837327485:web:372514d6d9d3cb235eb914",
  measurementId: "G-GK3BWW6VK7",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Firebase Services
export const auth = getAuth(app); // For Authentication
export const firestore = getFirestore(app); // For Firestore Database
export const storage = getStorage(app); // For Firebase Storage
export const messaging = getMessaging(app); // For Firebase Storage
const analytics = getAnalytics(app); // For Firebase Analytics
